import { render, staticRenderFns } from "./SecurityProfile.vue?vue&type=template&id=5f196a49&scoped=true&"
import script from "./SecurityProfile.vue?vue&type=script&lang=js&"
export * from "./SecurityProfile.vue?vue&type=script&lang=js&"
import style0 from "./SecurityProfile.vue?vue&type=style&index=0&id=5f196a49&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f196a49",
  null
  
)

component.options.__file = "SecurityProfile.vue"
export default component.exports